import { boolean, labeled } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    phone: boolean(Joi).label(labeled(label, 'Phone')),
    email: boolean(Joi).label(labeled(label, 'E-Mail'))
  });

export default {
  schema
};
